interface PShowToastProps {
  icon: React.ElementType;
  text: string;
  /**
   * `"error"` for a failure — announced as an alert. Every caller mounts the
   * toast TOGETHER with its text, and a live region inserted with its content
   * is announced by only some screen-reader/browser pairs; an alert is
   * announced on insertion (audit r2 L5). Anything else — "Copied", a request
   * accepted — is an outcome, not urgent: a polite status region.
   */
  tone?: "status" | "error";
}

export const PShowToast: React.FC<PShowToastProps> = ({ icon: Icon, text, tone = "status" }) => {
  return (
    // sm:left-[calc(50%-var(--ai-rail-push)/2)]: center within the app area
    // left of the docked AI rail, not the full viewport (var is 0 when closed).
    // Announced, not only shown — the DNS dialog's "Could not copy" reached
    // sighted users only (audit r1 L8).
    <div
      {...(tone === "error" ? { role: "alert" } : { role: "status", "aria-live": "polite" as const })}
      className="fixed bottom-8 left-1/2 sm:left-[calc(50%-var(--ai-rail-push)/2)] max-w-[calc(100vw-2rem)] body-2-medium transform -translate-x-1/2 cta-primary font-light-primary px-4 py-3 rounded-lg shadow-lg flex items-center space-x-2 z-60 animate-in fade-in slide-in-from-bottom-2 duration-200"
    >
      <span className="shrink-0 inline-flex" aria-hidden="true">
        <Icon size={20} />
      </span>
      <span className="min-w-0 break-words">{text}</span>
    </div>
  );
};
